var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_2571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6663 18.4598C35.6663 17.0332 35.5479 15.9922 35.2915 14.9126H18.621V21.3516H28.4062C28.209 22.9517 27.1436 25.3616 24.7762 26.9809L24.743 27.1965L30.0139 31.1867L30.3791 31.2223C33.7329 28.1955 35.6663 23.7421 35.6663 18.4598Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6208 35.4252C23.4148 35.4252 27.4393 33.8828 30.379 31.2225L24.7761 26.9811C23.2767 28.0028 21.2644 28.7161 18.6208 28.7161C13.9255 28.7161 9.9404 25.6895 8.51982 21.506L8.31159 21.5233L2.83083 25.6682L2.75916 25.8629C5.67893 31.5308 11.6764 35.4252 18.6208 35.4252Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52002 21.506C8.14519 20.4264 7.92826 19.2696 7.92826 18.0744C7.92826 16.879 8.14519 15.7224 8.5003 14.6428L8.49038 14.4128L2.94093 10.2014L2.75936 10.2857C1.55598 12.6378 0.865479 15.279 0.865479 18.0744C0.865479 20.8698 1.55598 23.5109 2.75936 25.8629L8.52002 21.506Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6208 7.43254C21.9549 7.43254 24.2039 8.83987 25.4863 10.0159L30.4973 5.23483C27.4197 2.43944 23.4148 0.723633 18.6208 0.723633C11.6764 0.723633 5.67893 4.61788 2.75916 10.2857L8.5001 14.6428C9.9404 10.4593 13.9255 7.43254 18.6208 7.43254Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_2571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.8211,
    height: 34.8211,
    fill: "white",
    transform: "translate(0.863525 0.723633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.ecbfbe28fbbb649b3d82126d37269504.svg";
export { ForwardRef as ReactComponent };